var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#184C7B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16675 13.1667H9.83342V8.16667H8.16675V13.1667ZM9.00008 0.666668C4.39591 0.666668 0.666748 4.39583 0.666748 9C0.666748 13.6042 4.39591 17.3333 9.00008 17.3333C13.6042 17.3333 17.3334 13.6042 17.3334 9C17.3334 4.39583 13.6042 0.666668 9.00008 0.666668ZM9.00008 15.6667C5.32508 15.6667 2.33341 12.675 2.33341 9C2.33341 5.325 5.32508 2.33333 9.00008 2.33333C12.6751 2.33333 15.6667 5.325 15.6667 9C15.6667 12.675 12.6751 15.6667 9.00008 15.6667ZM8.16675 6.5H9.83342V4.83333H8.16675V6.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOutlined);
export default __webpack_public_path__ + "static/media/info-outlined.cd2c7a33ccb5f450dd0bbe1f61d343d9.svg";
export { ForwardRef as ReactComponent };